
<mat-list>
  <mat-divider></mat-divider>
  @for (race of races; track race) {
    <mat-list-item (click)="onRaceSelected(race)" matRipple>
      <img
        matListItemAvatar
        src="./assets/images/sm-logga-2024-tr.png"
      />
      <div matListItemTitle>{{race.raceName}}</div>
      <div matListItemLine>SWE | National | Eventing</div>
      <div matListItemLine>{{ formatDateSvSE(race.raceBegin, race.raceEnd)}}</div>
    </mat-list-item>
    <mat-divider></mat-divider>
  }
</mat-list>
